import { Link, useNavigate } from "react-router-dom"
import "../../../theme/global.css"
import "../client-dashboard/header.css"

// images
import logo from "../../../images/patient_portal_logo.svg"
import home from "../../../images/home_unselected.svg"
import health from "../../../images/health_unselected.svg"
import message from "../../../images/chat_unselected.svg"
import appointment from "../../../images/appointemnt.png"
import carePlan from "../../../images/carePlan.png"
import pasword from "../../../images/pasword.png"
import { routes } from "../../../navigation/appRoutes"
import { ComponentState, useEffect, useState } from "react"
import logout from "../../../images/LOGOUT.svg"
import { useDispatch, useSelector } from "react-redux"
import Loading from "../../../components/loader/loader"
import { Modal, Snackbar } from "@mui/material"
import { ChangePassword } from "../../authFlow/login/change-password"
import moment from "moment"
import SessionTimeout from "./session-time-out"
import localKey from "../../../storage/localKey"
import { getLinkedAccountList, getParentInfo } from "../../../redux/actions"
import { auth } from "../../../services/authService"
import CarePlanResignNotification from "../../../screens/appFlow/care-plan-resign-alert"


const menuLinks = document.querySelectorAll(".menu-link");
menuLinks.forEach((link) => {
	link.addEventListener("click", () => {
		menuLinks.forEach((link) => {
			link.classList.remove("is-active");
		});
		link.classList.add("is-active");
	});
});

export const ClientDashBoard = () => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const state: ComponentState = useSelector(states => {
		return states;
	});
	const { authClientDetailedInfo, appIsImpersonate } = state['AuthReducer'];
	const { loadingMainApp, } = state['LoaderReducer'];
	const [isOpenChangePassword, setIsOpenChangePassword] = useState(false)
	const [callInitialApi, setCallInitialApi] = useState(false)
	const isUserAParent = localStorage.getItem(localKey.IS_USER_PARENT)
	const handleForgetPassword = () => {
		setIsOpenChangePassword(!isOpenChangePassword)
	}
	const { linkedAccountsListData,parentInfo } = state['AuthReducer']
	const handleChangePassword = () => {
		setIsOpenChangePassword(true)
	}
	const handleChangeNotification = () => {
		navigate(routes.notification)
	}

	useEffect(() => {
		if (!callInitialApi && isUserAParent) {
			dispatch(getLinkedAccountList())
			dispatch(getParentInfo())
		}
	}, [callInitialApi])

	const handleSwitch = async (selectedClient: any) => {
		const switchAccResponse: any = await auth.switchClient(selectedClient.clientUniqueId)
		if (switchAccResponse?.resultData && switchAccResponse?.status) {
			const response = switchAccResponse.resultData
			localStorage.setItem(localKey.AUTH_TOKEN, response.token)
			localStorage.setItem(localKey.IS_USER_PARENT, response.isParentAccount)
			window.location.reload();
		}
	}

	return (
		<>
			<article>
				<Modal
					open={isOpenChangePassword}
					onClose={() => { }}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<div>
						<ChangePassword onClose={handleForgetPassword} title={"Change Password"} />
					</div>
				</Modal>
				<div>
					<header className="header boxShadow" id="header">
						<nav className="navbar container-fluid">
							<div className="row">
								<a href="./home" className="brand"><img src={logo} alt="" /></a>
								{(isUserAParent && linkedAccountsListData?.status && linkedAccountsListData?.resultData
									&& linkedAccountsListData?.resultData.length > 0) && <div className="dropdown ">
										<button className="btn-common  white-btn"
											type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
											{'Switch Account'}
											<i className="fa fa-angle-down ml-2"></i>
										</button>
										<div className="dropdown-menu  " aria-labelledby="dropdownMenuButton">

											{
												linkedAccountsListData?.resultData?.map((dataItem: any) => {
													return <div
														className="td_link_bg_theme"
														onClick={() => {
															handleSwitch(dataItem)
														}}>

														<p className=" dropdown-item logoutext fw-500" >{`${dataItem.lName}, ${dataItem.fName}`}
														</p>
													</div>
												})}

										</div>
									</div>}
							</div>

							<div className="menu" id="menu">
								<ul className="menu-list">
									<li className="menu-item">
										<Link to="/home" className="menu-link " >
											<img src={home} className="menu-icon ion-md-home" alt="" />
											{/* <img src={selecthome} className="menu-icon ion-md-home" alt="" />         green image*/}
											<span className="menu-name">Home</span>
										</Link>
									</li>
									<li className="menu-item">
										<Link to="/diagnosis" className="menu-link " >
											<img src={health} className="menu-icon ion-md-home" alt="" />
											{/* <img src={selecthome} className="menu-icon ion-md-home" alt="" />         green image*/}
											<span className="menu-name">Diagnosis</span>
										</Link>
									</li>
									{/* mXHdKK2if1 */}
									<li className="menu-item">
										<Link to="/care-plan" className="menu-link " >
											<img src={carePlan} className="menu-icon ion-md-home" alt="" />
											{/* <img src={selecthome} className="menu-icon ion-md-home" alt="" />         green image*/}
											<span className="menu-name">Care Plan</span>
										</Link>
									</li>

									<li className="menu-item">
										<Link to="/appointment" className="menu-link " >
											<img src={appointment} className="menu-icon ion-md-home" alt="" />
											{/* <img src={selecthome} className="menu-icon ion-md-home" alt="" />         green image*/}
											<span className="menu-name">Appointments</span>
										</Link>
									</li>
									<li className="menu-item">
										<Link to="/message" className="menu-link " >
											<img src={message} className="menu-icon ion-md-home" alt="" />
											<span className="menu-name">Messaging</span>
										</Link>
									</li>

									<li className="menu-item">
										<CarePlanResignNotification></CarePlanResignNotification>
									</li>

									<li
										className="menu-item ">
										{/* <Link to="/login" className="menu-link">
									<img src={logout} className="menu-icon ion-md-home" alt="" />

										<span className="menu-name">Logout</span>
									</Link> */}
										<div className="dropdown ">
											<button className="btn-common btn-green dropdown-toggle rounded-circle user-btn p-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												{authClientDetailedInfo.fName && `${authClientDetailedInfo.fName.charAt(0)} ${authClientDetailedInfo.lName.charAt(0)}`}

											</button>
											<div className="dropdown-menu  " aria-labelledby="dropdownMenuButton">
												{/* <p className="dropdown-item " style={{ cursor: "pointer" }}>My Profile </p> */}
												<p className="dropdown-item logoutext" onClick={handleChangePassword} style={{ cursor: "pointer" }}>
													<img src={pasword} className="menu-icon ion-md-home" alt="password" />
													<span>Change Password</span></p>
												{/* <p className="dropdown-item logoutext" onClick={handleChangeNotification} style={{ cursor: "pointer" }}>
													<img src={pasword} className="menu-icon ion-md-home" alt="notifications" />
													<span>Change Notification Preferences</span></p> */}
												<p className="dropdown-item logoutext" style={{ cursor: "pointer" }}>
													<img src={logout} className="menu-icon ion-md-home" alt="" />
													<span className="" onClick={() => {
														sessionStorage.clear();
														localStorage.setItem("logout", Date.now().toString());
														localStorage.removeItem("logout");
														localStorage.clear();
														window.location.href = routes.auth;
													}}>Logout</span>
												</p>
											</div>
										</div>
									</li>
									{/* <li
										onClick={() => setIsOpenChangePassword(true)}
										className="menu-item cursor-pointer">
										<p className="menu-link" style={{ cursor: "pointer" }}>
											<img src={logout} className="menu-icon ion-md-home" alt="" />

											<span className="menu-name">Change password</span>
										</p>
									</li> */}

								</ul>
							</div>

						</nav>

					</header>
				</div>
			</article >
			{
				loadingMainApp && <Loading />
			}

			{
				appIsImpersonate &&
				<div className="headerBottomText">
					<div className="container-fluid">
						<p style={{ color: "#ffffff" }} className="m-0" > {moment(new Date()).format("M/D/yyyy hh:mm A")}: You are currently impersonating as {authClientDetailedInfo.fName && `${authClientDetailedInfo.fName}`} {authClientDetailedInfo.lName}</p>
					</div>
				</div>
			}

			{
				(isUserAParent && parentInfo?.accountUniqueId) &&
				<div className="headerBottomText">
					<div className="container-fluid">
						<p style={{ color: "#ffffff" }} className="m-0" > {
							`${moment(new Date()).format("M/D/yy hh:mm A")}: 
						You're logged in as ${authClientDetailedInfo.fName && `${parentInfo.fName} ${parentInfo.lName}`} (Parental Access) and viewing ${authClientDetailedInfo.fName &&
							`${authClientDetailedInfo.fName} ${authClientDetailedInfo.lName}`} health information.
						`
						}</p>
					</div>
				</div>
			}
			<SessionTimeout />
		</>)
}